import { Button, Group, Modal, Title } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import React from "react";
import { EntityMetadataCategoryCreate } from "../EntityMetadataCategoryCreate";
import { EntityMetadataCreate } from "../EntityMetadataCreate";

export function EntityMetadataManager({entityClass, categories}) {

    const [isManagerOpen, managerVisibility] = useDisclosure(false);

    return (<>
        <Modal
            opened={isManagerOpen}
            onClose={managerVisibility.close}
            title={
                <Group noWrap>
                    <Title order={2} mr="auto">Metadados</Title>
                    <EntityMetadataCategoryCreate entityClass={entityClass} />
                </Group>
            }
            size="lg"
            styles={{
                header: {
                    zIndex: 1
                }
            }}
        >
            <EntityMetadataCreate categories={categories} />
        </Modal>

        <Button variant="subtle" onClick={managerVisibility.open}>Gerenciar</Button>
    </>)
}